const API_BASE = (process.env.REACT_APP_API_URL || "/api").replace(/\/$/, "");

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  let data = null;

  try {
    data = await response.json();
  } catch (_) {
    data = null;
  }

  if (!response.ok) {
    const error = new Error(
      data?.detail || "Request failed"
    );

    error.status = response.status;
    throw error;
  }

  return data;
};

const authHeaders = () => {
  const token = sessionStorage.getItem("boostf_mentor_token");

  return token
    ? { Authorization: `Bearer ${token}` }
    : {};
};

export const loginMentor = async (email, password) => {
  const data = await request("/mentor/login", {
    method: "POST",
    body: JSON.stringify({
      email,
      password,
    }),
  });

  sessionStorage.setItem(
    "boostf_mentor_token",
    data.access_token
  );

  return data;
};

export const logoutMentor = () => {
  sessionStorage.removeItem("boostf_mentor_token");
};

export const isMentorLoggedIn = () =>
  Boolean(
    sessionStorage.getItem("boostf_mentor_token")
  );

export const getMentor = () =>
  request("/mentor/me", {
    headers: authHeaders(),
  });

export const getStores = () =>
  request("/mentor/stores", {
    headers: authHeaders(),
  });

export const createStore = (payload) =>
  request("/mentor/stores", {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });

export const updateStore = (id, payload) =>
  request(`/mentor/stores/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });

export const deleteStore = (id) =>
  request(`/mentor/stores/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  });

export const getPublicBusinessResults = () =>
  request("/public/business-results");